// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string, any } from "@altostra/type-validations/lib/primitives";

export const isEngagementPresetLandingPageTemplatesDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      html: maybe(any, true),
      last_edited_at: number,
    })
  ),
});
